export default __webpack_public_path__ + "static/media/shadow.6acc1ea2.svg";